export default __webpack_public_path__ + "static/media/548.a0a177a5.png";